import React from 'react';
import { FileTextIcon } from 'lucide-react';
import { courtDocuments } from '../data/documents';
export function DocumentsSidebar() {
  return <aside aria-labelledby="sidebar-documents-heading" className="border-t border-ink pt-4 lg:sticky lg:top-24" data-id="element-38" data-mp="7fkow5zq9zbv">
      <h2 id="sidebar-documents-heading" className="font-sans text-[11px] font-semibold uppercase tracking-[0.18em] text-ink" data-id="element-39" data-mp="geejjqti0fms">
        Documents &amp; Records
      </h2>

      <ul className="mt-4" data-id="element-40" data-mp="q47ucpltgqpz">
        {courtDocuments.map(document => <li key={document.id} className="border-b border-rule py-4 first:pt-0" data-id="element-41" data-mp="q3y4d20rujka">
            <a href={document.url ?? '#court-documents'} {...document.url ? {
          target: '_blank',
          rel: 'noopener noreferrer'
        } : {}} className="group flex gap-3 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ink focus-visible:ring-offset-2" data-id="element-42" data-mp="143gxanl0hoc0">
              <FileTextIcon className="mt-[3px] h-4 w-4 shrink-0 text-ink-faint" strokeWidth={1.5} aria-hidden="true" data-id="element-43" data-mp="2ressratpfm4r" />
              <span data-id="element-44" data-mp="2wbatlzlwz0bt">
                <span className="block font-sans text-[13.5px] font-medium leading-[1.45] text-ink transition-colors duration-150 ease-out group-hover:text-ink-muted" data-id="element-45" data-mp="31d051gd1tg0f">
                  {document.title}
                </span>
                <span className="mt-1 block font-sans text-[12px] leading-[1.5] text-ink-faint" data-id="element-46" data-mp="3a40jif4kcpe7">
                  {document.caseNumber ?? document.court}
                </span>
              </span>
            </a>
          </li>)}
      </ul>

      <p className="mt-5 font-sans text-[12px] leading-[1.6] text-ink-faint" data-id="element-47" data-mp="3k1dlofptw6af">
        Records referenced in this report are listed in full at the end of the article.
      </p>
    </aside>;
}